module.exports = __webpack_public_path__ + "img/settings.a8892ec5.svg";